/**
 * React Query hook for issue list
 */

import { useQuery } from '@tanstack/react-query'
import type { ListIssuesOptions } from '../IssueRepository'
import { useIssueRepository } from '../IssueRepositoryContext'
import { useExperienceMode } from '../../context/ExperienceModeContext'

export type UseIssuesOptions = ListIssuesOptions

export function useIssues(options?: UseIssuesOptions) {
  const repository = useIssueRepository()
  const { experienceMode } = useExperienceMode()

  return useQuery({
    queryKey: ['issues', experienceMode, options],
    queryFn: () => repository.listIssues(options),
    staleTime: 30_000,
  })
}
